'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');

function _interopNamespaceDefaultOnly (e) { return { __proto__: null, 'default': e }; }

var clsx_m__namespace = /*#__PURE__*/_interopNamespaceDefaultOnly(clsx_m);

var require$$7 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(clsx_m__namespace);

module.exports = require$$7;
